import { render, staticRenderFns } from "./InterBtnBox.vue?vue&type=template&id=a46403ac&scoped=true&"
import script from "./InterBtnBox.vue?vue&type=script&lang=js&"
export * from "./InterBtnBox.vue?vue&type=script&lang=js&"
import style0 from "./InterBtnBox.vue?vue&type=style&index=0&id=a46403ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46403ac",
  null
  
)

export default component.exports